<template>
    <AlertsComponent :errors="errors" />
    <MessageCard
        :message="!isAddAction? 'Note: IATSE NBF will not received your request until you click the “Assign Funds” button and proceed through the remaining steps of this form.' : 'Note that you are still in Step 2 of the form adding beneficiaries. IATSE NBF will not received your request until you click the “Assign Funds” button and proceed through the remaining steps of this form.'"
        type="primary" iconClass="iatse-icon-alarm" classes="info_card_full"
    />
    <div class="plan-content">
        <BeneficiaryCard v-if="isAddAction && newBeneficiariesCard.length" title="Beneficiary" mode="multiple"
            :data="newBeneficiariesCard" :deleteItem="true" :hasDivider="true" customClass="green-card beneficiary-card"
            @delete="deleteItem" @edit="editItem"/>
        <form id="assign-fund-form" class="form assign-fund" method="post">
            <h2> Select Fund </h2>
            <FundCard v-for="(fund, key) in funds" :title="fund" :key="key" @show-buttons="handleShowButtons" />

            <div v-if="showActionButtons" class="action-buttons">
                <button class="btn btn-primary plan-modal" @click.prevent="handleSave" :disabled="loading">
                    {{ saveButtonText }}
                </button>
                <button type="button" @click.prevent="resetAssignments" class="btn btn-secondary" :disabled="loading"> Discard </button>
            </div>
        </form>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, onMounted } from 'vue';
import { useModalStore } from '@/stores/modal';
import { useBeneficiaryStore } from '@/stores/beneficiary';
import { useParticipantStore } from '@/stores/participant';

import BeneficiaryCard from '@/components/cards/BeneficiaryCard.vue';
import FundCard from '@/components/cards/FundCard.vue';

export default defineComponent({
    components: {
        BeneficiaryCard,
        FundCard
    },
    setup(_, { emit }) {
        const loading = ref(false);
        const showButtons = ref(false);
        const errors = ref<string[]>([]);
        const modalStore = useModalStore();
        const beneStore = useBeneficiaryStore();
        const openModal = modalStore.openModal;
        const newBeneficiariesCard = computed(() => beneStore.beneCards);
        const showActionButtons = computed(() => beneStore.isAddAction || showButtons.value || beneStore.isDeleteAction ? true : false);
        const saveButtonText = computed(() => {
            if (loading.value) {
                return 'Submitting';
            } else if (beneStore.isAddAction || beneStore.isDeleteAction) {
                return 'Save and Submit Beneficiary(ies)';
            }

            return 'Save and Submit Updates';
        });

        const modalProps = {
            title: 'Fund Assigned',
            content: {
                type: "text",
                value: beneStore.isAddAction ? beneStore.beneficiaryNames : 'Assignments have been updated successfully.',
                icon: 'iatse-icon-user-verified'
            },
            onConfirmButton: 'Return to Beneficiary(ies) Summary',
            onConfirm: () => modalStore.closeAbove(0)
        }


        const handleSubmit = async () => {
            loading.value = true;
            beneStore.filterAssignments();
            errors.value = await beneStore.handleSubmitNewBenes(false) ?? [];

            if (!errors.value.length) {
                await beneStore.fetchBeneficiaries();
                beneStore.reloadAssignments();

                openModal('success-modal', null, 'modal-success', null, modalProps)
            }

            setTimeout(() => errors.value = [], 2000)

            loading.value = false;
        }

        const deleteItem = (index: number) => {
            beneStore.newBeneficiaries.splice(index, 1);
            beneStore.newBeneficiariesCard.splice(index, 1);
            beneStore.reloadAssignments();
        }

        const editItem = (index: number) => {
            beneStore.editDependent(index);
            beneStore.dependentEdit = true;
            closeModal();
        }

        const closeModal = () => {
            emit('close');
        }

        const resetAssignments = () => {
            beneStore.discard = false;
            beneStore.getSliders();
            beneStore.getBeneCards();
            beneStore.initAssignments();
            beneStore.discard = true;
        }

        const handleShowButtons = () => {
            showButtons.value = true
        }

        const handleSave = () => {
            if (beneStore.isAddAction && !beneStore.newBeneficiaries.length) {
                errors.value.push('Please add at least one Beneficiary!');
            }
            else {
                handleSubmit();
            }
        }

        onMounted(() => {
            beneStore.reloadAssignments();
            useParticipantStore().currentStep = 2;
        })

        return {
            errors,
            loading,
            isAddAction: beneStore.isAddAction,
            funds: beneStore.eligibleFunds,
            newBeneficiariesCard,
            showActionButtons,
            saveButtonText,
            handleShowButtons,
            handleSave,
            closeModal,
            deleteItem,
            editItem,
            resetAssignments,
        };
    },
})
</script>